{
  "AUTOMATION": {
    "HEADER": "Automation",
    "DESCRIPTION": "Automation can replace and streamline existing processes that require manual effort, such as adding labels and assigning conversations to the most suitable agent. This allows the team to focus on their strengths while reducing time spent on routine tasks.",
    "LEARN_MORE": "Learn more about automation",
    "HEADER_BTN_TXT": "Add Automation Rule",
    "LOADING": "Fetching automation rules",
    "ADD": {
      "TITLE": "Add Automation Rule",
      "SUBMIT": "Create",
      "CANCEL_BUTTON_TEXT": "Hætta við",
      "FORM": {
        "NAME": {
          "LABEL": "Rule Name",
          "PLACEHOLDER": "Enter rule name",
          "ERROR": "Name is required"
        },
        "DESC": {
          "LABEL": "Description",
          "PLACEHOLDER": "Enter rule description",
          "ERROR": "Description is required"
        },
        "EVENT": {
          "LABEL": "Event",
          "PLACEHOLDER": "Please select one",
          "ERROR": "Event is required"
        },
        "PHASE": {
          "LABEL": "Áfangi"
        },
        "ORDER": {
          "LABEL": "Röð",
          "ERROR": "Röð er nauðsynleg"
        },
        "CONDITIONS": {
          "LABEL": "Conditions"
        },
        "ACTIONS": {
          "LABEL": "Aðgerðir"
        }
      },
      "CONDITION_BUTTON_LABEL": "Add Condition",
      "ACTION_BUTTON_LABEL": "Add Action",
      "API": {
        "SUCCESS_MESSAGE": "Automation rule added successfully",
        "ERROR_MESSAGE": "Gat ekki búið til sjálfvirknireglu. Reyndu aftur síðar"
      }
    },
    "LIST": {
      "TABLE_HEADER": {
        "PHASE": "Áfangi",
        "ORDER": "Röð",
        "NAME": "Nafn",
        "DESCRIPTION": "Description",
        "ACTIVE": "Active",
        "CREATED_ON": "Created on",
        "WAIT": "Bið"
      },
      "404": "No automation rules found",
      "TABS": {
        "ALL": "Allar",
        "INSTANT": "Við atburð",
        "DELAYED": "Með töf"
      },
      "WAITS": "Bíður {duration}"
    },
    "DELETE": {
      "TITLE": "Delete Automation Rule",
      "SUBMIT": "Eyða",
      "CANCEL_BUTTON_TEXT": "Hætta við",
      "CONFIRM": {
        "TITLE": "Staðfesta eyðingu",
        "MESSAGE": "Ertu viss um að þú viljir eyða",
        "YES": "Já, eyða",
        "NO": "Nei, hætta við eyðingu"
      },
      "API": {
        "SUCCESS_MESSAGE": "Automation rule deleted successfully",
        "ERROR_MESSAGE": "Gat ekki eytt sjálfvirknireglu. Reyndu aftur síðar"
      }
    },
    "EDIT": {
      "TITLE": "Edit Automation Rule",
      "SUBMIT": "Uppfæra",
      "CANCEL_BUTTON_TEXT": "Hætta við",
      "API": {
        "SUCCESS_MESSAGE": "Automation rule updated successfully",
        "ERROR_MESSAGE": "Ekki tókst að uppfæra sjálfvirknireglu. Reyndu aftur síðar"
      }
    },
    "CLONE": {
      "TOOLTIP": "Clone",
      "API": {
        "SUCCESS_MESSAGE": "Automation cloned successfully",
        "ERROR_MESSAGE": "Ekki tókst að afrita sjálfvirknireglu, vinsamlegast reyndu aftur síðar"
      }
    },
    "FORM": {
      "EDIT": "Breyta",
      "CREATE": "Create",
      "DELETE": "Eyða",
      "CANCEL": "Hætta við",
      "RESET_MESSAGE": "Að breyta gerð viðburðar mun endurstilla skilyrðin og viðburðina sem þú hefur bætt við hér að neðan"
    },
    "CONDITION": {
      "DELETE_MESSAGE": "Þú þarft að hafa að minnsta kosti eitt skilyrði til að vista",
      "CONTACT_CUSTOM_ATTR_LABEL": "Contact Custom Attributes",
      "CONVERSATION_CUSTOM_ATTR_LABEL": "Conversation Custom Attributes"
    },
    "ACTION": {
      "DELETE_MESSAGE": "Þú þarft að hafa að minnsta kosti eina aðgerð til að vista",
      "TEAM_MESSAGE_INPUT_PLACEHOLDER": "Enter your message here",
      "TEAM_DROPDOWN_PLACEHOLDER": "Select teams",
      "EMAIL_INPUT_PLACEHOLDER": "Enter email",
      "URL_INPUT_PLACEHOLDER": "Enter URL",
      "SENDER_DROPDOWN_PLACEHOLDER": "Veldu tölvupóstinnhólf og netfang sendanda",
      "SUBJECT_INPUT_PLACEHOLDER": "Efni tölvupósts",
      "SMS_INBOX_DROPDOWN_PLACEHOLDER": "Veldu SMS-innhólfið til að senda úr",
      "SMS_MESSAGE_INPUT_PLACEHOLDER": "Sláðu inn texta SMS-skilaboðanna",
      "SMS_COUNTER": "{length}/{limit} stafir, {segments} SMS (áður en breytur eru fylltar út)"
    },
    "TOGGLE": {
      "ACTIVATION_TITLE": "Activate Automation Rule",
      "DEACTIVATION_TITLE": "Deactivate Automation Rule",
      "ACTIVATION_DESCRIPTION": "Þessi aðgerð mun virkja sjálfvirkniregluna '{automationName}'. Ertu viss um að þú viljir halda áfram?",
      "DEACTIVATION_DESCRIPTION": "Þessi aðgerð mun slökkva á sjálfvirknireglunni '{automationName}'. Ertu viss um að þú viljir halda áfram?",
      "ACTIVATION_SUCCESFUL": "Automation Rule Activated Successfully",
      "DEACTIVATION_SUCCESFUL": "Automation Rule Deactivated Successfully",
      "ACTIVATION_ERROR": "Gat ekki virkjað sjálfvirkni, vinsamlegast reyndu aftur síðar",
      "DEACTIVATION_ERROR": "Gat ekki slökkt á sjálfvirkni, vinsamlegast reyndu aftur síðar",
      "CONFIRMATION_LABEL": "Já",
      "CANCEL_LABEL": "Nei"
    },
    "ATTACHMENT": {
      "UPLOAD_ERROR": "Gat ekki hlaðið upp viðhengi, vinsamlegast reyndu aftur",
      "LABEL_IDLE": "Upload Attachment",
      "LABEL_UPLOADING": "Hleður upp...",
      "LABEL_UPLOADED": "Successfully Uploaded",
      "LABEL_UPLOAD_FAILED": "Upload Failed"
    },
    "ERRORS": {
      "ATTRIBUTE_KEY_REQUIRED": "Attribute key is required",
      "FILTER_OPERATOR_REQUIRED": "Filter operator is required",
      "VALUE_REQUIRED": "Value is required",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "Value must be between 1 and 998",
      "ACTION_PARAMETERS_REQUIRED": "Action parameters are required",
      "ATLEAST_ONE_CONDITION_REQUIRED": "At least one condition is required",
      "ATLEAST_ONE_ACTION_REQUIRED": "At least one action is required"
    },
    "ACTION_NOTICES": {
      "SKIP_AUTO_PRIORITY": "Þessi aðgerð virkar aðeins þegar áfangi reglunnar er stilltur á 'Fyrir merkingu'.",
      "SKIP_AUTO_LABELING": "Þessi aðgerð virkar aðeins þegar áfangi reglunnar er stilltur á 'Fyrir merkingu'.",
      "MOVE_CONVERSATION_TO_INBOX": "Aðeins er hægt að færa tölvupóst- og vefspjallsamtöl í tölvupóstinnhólf, og vefspjall aðeins ef tengiliðurinn er með netfang. Annars verður samtalið áfram á sínum stað og í staðinn er bætt við einkaathugasemd.",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Hefur nýtt samtal við tengiliðinn í völdu tölvupóstinnhólfi, sendir honum skilaboðin í tölvupósti og merkir samtalið sem leyst. Þetta gerist í hvert sinn sem reglan keyrir. Ef tengiliðurinn er ekki með netfang er ekkert sent og einkaathugasemd bætt við í staðinn.",
      "SEND_SMS_IN_NEW_CONVERSATION": "Hefur nýtt samtal við tengiliðinn í völdu SMS-innhólfi, sendir honum skilaboðin sem SMS og merkir samtalið sem leyst. Þetta gerist í hvert sinn sem reglan keyrir. Skilaboðin eru venjulegur texti án viðhengja. Ef tengiliðurinn er ekki með símanúmer er ekkert sent og einkaathugasemd bætt við í staðinn."
    },
    "NOTICES": {
      "AI_PROMPT": "Greitt er fyrir hvert einstakt mat.",
      "INCOMING_MESSAGES_COUNT": "Þetta vísar til fjölda móttekinna skilaboða í samtalinu.",
      "OUTGOING_MESSAGES_COUNT": "Þetta vísar til fjölda sendra skilaboða í samtalinu."
    },
    "PHASE": {
      "BEFORE_LABELING": "Fyrir merkingu",
      "AFTER_LABELING": "Eftir merkingu"
    },
    "NONE_OPTION": "Enginn",
    "MESSAGE_TYPE_VALUES": {
      "INCOMING": "Incoming Message",
      "OUTGOING": "Outgoing Message",
      "PRIVATE": "Private Note",
      "AI_SUMMARY": "AI Summary"
    },
    "YES_NO_VALUES": {
      "YES": "Já",
      "NO": "Nei"
    },
    "MESSAGE_SOURCE_TYPE_VALUES": {
      "FACEBOOK_MESSENGER": "Facebook Messenger",
      "INSTAGRAM_DM": "Bein skilaboð á Instagram",
      "FACEBOOK_COMMENT": "Athugasemd á Facebook"
    },
    "EVENTS": {
      "CONVERSATION_CREATED": "Samtal stofnað",
      "CONVERSATION_UPDATED": "Samtali breytt",
      "MESSAGE_CREATED": "Skilaboð stofnuð",
      "CONVERSATION_OPENED": "Samtal opnað",
      "CONVERSATION_RESOLVED": "Samtal leyst",
      "PHONE_CALL_FINISHED": "Símtali lokið"
    },
    "ACTIONS": {
      "ASSIGN_AGENT": "Úthluta til þjónustufulltrúa",
      "ASSIGN_TEAM": "Úthluta teymi",
      "ADD_LABEL": "Bæta við merkingu",
      "REMOVE_LABEL": "Fjarlægja merkingu",
      "SEND_EMAIL_TO_TEAM": "Senda tölvupóst á teymi",
      "SEND_EMAIL_TRANSCRIPT": "Senda afrit í tölvupósti",
      "SEND_EMAIL_TRANSCRIPT_WITH_DETAILS": "Senda ítarlegt afrit í tölvupósti",
      "MUTE_CONVERSATION": "Þagga samtal",
      "SNOOZE_CONVERSATION": "Blunda samtali",
      "RESOLVE_CONVERSATION": "Leysa samtal",
      "OPEN_CONVERSATION": "Opna samtal",
      "SEND_WEBHOOK_EVENT": "Senda webhook atburð",
      "SEND_ATTACHMENT": "Senda viðhengi",
      "SEND_MESSAGE": "Senda skilaboð",
      "ADD_NOTE": "Bæta við athugasemd",
      "CHANGE_PRIORITY": "Breyta forgangi",
      "ADD_SLA": "Bæta við SLA",
      "SKIP_AUTO_PRIORITY": "Sleppa sjálfvirkum forgangi",
      "SKIP_AUTO_LABELING": "Sleppa sjálfvirkri merkingu",
      "AUTO_TRANSLATE": "Þýða skilaboð",
      "AUTO_TRANSLATE_CONVERSATION": "Þýða samtal",
      "MOVE_CONVERSATION_TO_INBOX": "Færa samtal í innhólf",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Senda skilaboð í nýju samtali",
      "SEND_SMS_IN_NEW_CONVERSATION": "Senda SMS í nýju samtali",
      "STOP_PROCESSING_RULES": "Hætta að vinna úr reglum"
    },
    "ATTRIBUTES": {
      "AI_FILTER": "Gervigreindarsía",
      "MESSAGE_TYPE": "Tegund skilaboða",
      "MESSAGE_CONTAINS": "Innihald skilaboða",
      "EMAIL": "Tölvupóstur tengiliðs",
      "INBOX": "Innhólf",
      "CHANNEL_TYPE": "Tegund innhólfs",
      "CONVERSATION_LANGUAGE": "Tungumál samtals",
      "PHONE_NUMBER": "Símanúmer",
      "STATUS": "Staða",
      "BROWSER_LANGUAGE": "Tungumál vafra",
      "MAIL_SUBJECT": "Viðfangsefni tölvupósts",
      "COUNTRY_NAME": "Land",
      "MARKETPLACE_COUNTRY": "Land markaðstorgs",
      "REFERER_LINK": "Tilvísunartengill",
      "ASSIGNEE_NAME": "Ábyrgðarmaður",
      "TEAM_NAME": "Teymi",
      "PRIORITY": "Forgangur",
      "CALL_DIRECTION": "Stefna símtals",
      "MISSED_CALL": "Ósvarað símtal",
      "MISSED_CALL_COUNT": "Fjöldi ósvaraðra símtala",
      "MESSAGE_SOURCE_TYPE": "Uppruni skilaboða",
      "INCOMING_MESSAGE_COUNT": "Fjöldi móttekinna skilaboða",
      "OUTGOING_MESSAGE_COUNT": "Fjöldi sendra skilaboða",
      "LABEL": "Merking",
      "EMAIL_RECIPIENTS": "Móttakandi tölvupósts",
      "EMAIL_AUTO_REPLY": "Tölvupóstur er sjálfvirkt svar",
      "ATTACHMENT_EXTENSION": "Skráarending viðhengis",
      "EXTENSION": "Hringd aukalína",
      "WORKING_HOURS": "Innan vinnutíma",
      "AGENT_REPLIED": "Þjónustufulltrúi hefur svarað frá stöðubreytingu"
    },
    "WAIT": {
      "RUN_LABEL": "Keyra aðgerðirnar",
      "INSTANT": "Við atburð",
      "DELAYED": "Með töf",
      "TRIGGER_LABEL": "Bíða þar til",
      "TRIGGERS": {
        "CONVERSATION_STATUS": "Samtal helst í stöðu",
        "CUSTOMER_UNRESPONSIVE": "Viðskiptavinurinn svarar ekki þjónustufulltrúa",
        "AGENT_UNRESPONSIVE": "Viðskiptavinurinn fær ekki svar frá þjónustufulltrúa"
      },
      "STATUS_LABEL": "Staða",
      "STATUSES": {
        "OPEN": "Opið",
        "PENDING": "Í bið",
        "SNOOZED": "Blundað",
        "RESOLVED": "Leyst"
      },
      "DELAY_LABEL": "Biðtími",
      "DELAY_ERROR": "Sláðu inn biðtíma frá 1 mínútu upp í 30 daga",
      "DURATION": {
        "MINUTES": "{count} mín",
        "HOURS": "{count} klst",
        "DAYS": "{count} d"
      },
      "EXPLANATION": {
        "CONVERSATION_STATUS": "Aðgerðirnar keyra þegar samtal hefur verið í stöðunni {status} í {duration}. Ef staðan breytist fyrr falla þær niður. Merki, vinnutími og svör þjónustufulltrúa eru athuguð þegar biðinni lýkur.",
        "CUSTOMER_UNRESPONSIVE": "Aðgerðirnar keyra þegar viðskiptavinurinn hefur ekki svarað í {duration} eftir skilaboð þjónustufulltrúa. Svar viðskiptavinar fellir þær niður; ný skilaboð þjónustufulltrúa hefja biðina upp á nýtt.",
        "AGENT_UNRESPONSIVE": "Aðgerðirnar keyra þegar viðskiptavinurinn hefur beðið í {duration} án svars frá þjónustufulltrúa. Svar þjónustufulltrúa fellir þær niður."
      }
    }
  }
}
